import '@babel/polyfill'
import './mock'
import './style.scss'
import Vue from 'vue'
import axios from 'common/js/axios'
import storejs from 'store'
import { Toast } from 'vant'
import fundebug from 'fundebug-javascript'
import fundebugVue from 'fundebug-vue'
const { vars } = require('./config')

if (process.env.VUE_APP_ENV === 'prod') {
  fundebug.apikey = '7c3f418b6319a3c8a15ebf8b209305e3993ea5e0b3c402e37758edc233434696'
  fundebug.filters = [
    {
      type: /^unhandledrejection$/
    }
  ]
  fundebug.silentResource = true
  fundebugVue(fundebug, Vue)
}

Vue.config.productionTip = false

Vue.use(vars)
Vue.use(axios)
// eslint-disable-next-line
Vue.use(Toast)
Vue.prototype.$loading = () => {
  return Toast.loading({
    message: 'Loading...',
    duration: 0,
    forbidClick: true
  })
}
Vue.prototype.$loading.clear = () => {
  return Toast.clear()
}

Vue.prototype.$storejs = storejs

if (process.env.VUE_APP_ENV !== 'prod') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line
  new VConsole()
} else {
  const AlloyLever = require('alloylever')
  AlloyLever.config({
    cdn: 'https://a-img.pangku.com/common/181104/vconsole.min.js'
  })
}
